module.exports = __webpack_public_path__ + "static/media/icomoon.4cebb9c0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/icomoon.ttf?l4wga5
// module id = 1643
// module chunks = 0